import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
//import {Route, Router} from 'react-router'
import 'bootstrap/dist/css/bootstrap.css';
import 'react-web-tabs/dist/react-web-tabs.css';
import { Provider } from 'react-redux';
import store from './app/components/store/index'

import App from './app/App';

ReactDOM.render(
  <Provider store={store}>
        <App />
        </Provider>,
    document.getElementById('root')
);

registerServiceWorker();
